import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { Collections } from "src/app/_models/Collection";
import { Group, AddGroupDto, GroupList, UpdateGroupListDTO, OrgCentreIdsDto } from "src/app/_models/Group";
import { GroupActionTypes } from "src/app/constants/StoreConstants";

export const AddGroup = createAction(
    GroupActionTypes.AddGroup,
    props<{addGroupDto: AddGroupDto}>()
);
export const AddGroupSuccess = createAction(
    GroupActionTypes.AddGroupSuccess,
    props<{result: Group}>()
);
export const AddGroupError = createAction(
    GroupActionTypes.AddGroupError,
    props<{crudError: HttpErrorResponse}>()
);

export const ResetGroupState = createAction(
    GroupActionTypes.ResetGroupState,
);

export const GetGroupTable = createAction(
    GroupActionTypes.GetGroupTable,
    props<{pageIndex: number}>()
);

export const GetGroupTableSuccess = createAction(
    GroupActionTypes.GetGroupTableSuccess,
    props<{result: GroupList[]}>()
);

export const GetGroupTableError = createAction(
    GroupActionTypes.GetGroupTableError,
    props<{error: any}>()
);

export const GetGroupTableLength = createAction(
    GroupActionTypes.GetGroupTableLength
);

export const GetGroupTableLengthSuccess = createAction(
    GroupActionTypes.GetGroupTableLengthSuccess,
    props<{result: number}>()
);

export const GetGroupTableLengthError = createAction(
    GroupActionTypes.GetGroupTableLengthError,
    props<{error: any}>()
);

export const UpdateGroupTable = createAction(
    GroupActionTypes.UpdateGroupTable,
    props<{request: UpdateGroupListDTO}>()
);

export const UpdateGroupTableError = createAction(
    GroupActionTypes.UpdateGroupTableError,
    props<{error: any}>()
);

export const GetOrgCentreGroupList = createAction(
    GroupActionTypes.GetOrgCentreGroupList,
    props<{collections: Collections[]}>(),
);

export const GetOrgCentreGroupListSuccess = createAction(
    GroupActionTypes.GetOrgCentreGroupListSuccess,
    props<{result: Group[]}>(),
);

export const GetOrgCentreGroupListError = createAction(
    GroupActionTypes.GetOrgCentreGroupListError,
    props<{error: HttpErrorResponse}>(),
);

export const ResetOrgCentreGroupList = createAction(
    GroupActionTypes.ResetOrgCentreGroupList,
);

export const DeleteGroups = createAction(
    GroupActionTypes.DeleteGroups,
    props<{ params: number[]}>()
);

export const DeleteGroupsSuccess = createAction(
    GroupActionTypes.DeleteGroupsSuccess,
    props<{ isDeletedSuccessFully: boolean }>()
);

export const DeleteGroupsError = createAction(
    GroupActionTypes.DeleteGroupsError,
    props<{ error: any }>()
);

export const GetCurrentPageNumber = createAction(
    GroupActionTypes.GetCurrentPageNumber,
    props<{ pageIndex: number }>()
  );
  
  export const GetCurrentPageNumberSuccess = createAction(
    GroupActionTypes.GetCurrentPageNumberSuccess,
    props<{ currentPageNumber: number }>()
  );
  
  export const GetCurrentPageNumberError = createAction(
    GroupActionTypes.GetCurrentPageNumberError,
    props<{ error: any }>()
  );

  export const ProcessGetLearnerIdsToAssign = createAction(
    GroupActionTypes.ProcessGetLearnerIdsToAssign,
    props<{ groupIds: number[] }>()
  );
  
  export const ProcessGetLearnerIdsToAssignSuccess = createAction(
    GroupActionTypes.ProcessGetLearnerIdsToAssignSuccess,
    props<{ learnerIds: number[] }>()
  );
  
  export const ProcessGetLearnerIdsToAssignError = createAction(
    GroupActionTypes.ProcessGetLearnerIdsToAssignError,
    props<{ error: HttpErrorResponse }>()
  );
  
  export const GetGroupByOrgOptionalCentre = createAction(
    GroupActionTypes.GetGroupByOrgOptionalCentre,
    props<{ orgCentreIds: OrgCentreIdsDto }>()
  );
  
  export const GetGroupByOrgOptionalCentreSuccess = createAction(
    GroupActionTypes.GetGroupByOrgOptionalCentreSuccess,
    props<{ result: Group[] }>()
  );
  
  export const GetGroupByOrgOptionalCentreError = createAction(
    GroupActionTypes.GetGroupByOrgOptionalCentreError,
    props<{ error: HttpErrorResponse }>()
  );

  export const GetGroupByOrgOptionalCentreTutorFlow = createAction(
    GroupActionTypes.GetGroupByOrgOptionalCentreTutorFlow,
    props<{ orgCentreIds: OrgCentreIdsDto }>()
  );
  
  export const GetGroupByOrgOptionalCentreTutorFlowSuccess = createAction(
    GroupActionTypes.GetGroupByOrgOptionalCentreTutorFlowSuccess,
    props<{ result: Group[] }>()
  );
  
  export const GetGroupByOrgOptionalCentreTutorFlowError = createAction(
    GroupActionTypes.GetGroupByOrgOptionalCentreTutorFlowError,
    props<{ error: HttpErrorResponse }>()
  );